import { render, staticRenderFns } from "./no-permissions.vue?vue&type=template&id=08764cdc&scoped=true"
import script from "./no-permissions.vue?vue&type=script&lang=js"
export * from "./no-permissions.vue?vue&type=script&lang=js"
import style0 from "./no-permissions.vue?vue&type=style&index=0&id=08764cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08764cdc",
  null
  
)

export default component.exports